import { api, endpoints } from "api/api";
import { AxiosPromise } from "axios";
import { RegistrationTrancheStatus } from "consts";

const fetch = (userId: number, courseId: number): AxiosPromise<FetchUserPaymentsResponse> => {
  return api.get<FetchUserPaymentsResponse>(endpoints.USER_PAYMENTS.GET(userId, courseId));
};

const changeStatus = (
  userId: number,
  courseId: number,
  courseTrancheId: number,
  body: { sendEmail: boolean; status: number; salesDate?: Date; comment?: string },
): AxiosPromise<void> => {
  return api.put<void>(endpoints.USER_PAYMENTS.CHANGE_STATUS(userId, courseId, courseTrancheId), body);
};

const changePrice = (
  userId: number,
  courseId: number,
  courseTrancheId: number,
  body: { amount: number },
): AxiosPromise<void> => {
  return api.put<void>(endpoints.USER_PAYMENTS.CHANGE_PRICE(userId, courseId, courseTrancheId), body);
};

const postponePayment = (
  userId: number,
  courseId: number,
  courseTrancheId: number,
  newDate: Date,
): AxiosPromise<void> => {
  return api.put<void>(endpoints.USER_PAYMENTS.POSTPONE_PAYMENT(userId, courseId, courseTrancheId), { newDate });
};

const createTranche = (userId: number, courseId: number, body: AddRegistrationTrancheRequest): AxiosPromise<void> => {
  return api.post<void>(endpoints.USER_PAYMENTS.CREATE_TRANCHE(userId, courseId), body);
};

const updateTranche = (
  userId: number,
  courseId: number,
  courseTrancheId: number,
  body: UpdateTrancheRequest,
): AxiosPromise<void> => {
  return api.put<void>(endpoints.USER_PAYMENTS.UPDATE_TRANCHE(userId, courseId, courseTrancheId), body);
};

const deleteTranche = (
  userId: number,
  courseId: number,
  courseTrancheId: number,
  trancheName: string,
): AxiosPromise<void> => {
  return api.delete<void>(endpoints.USER_PAYMENTS.DELETE_TRANCHE(userId, courseId, courseTrancheId, trancheName));
};

export const userPaymentsApi = {
  fetch,
  changePrice,
  changeStatus,
  postponePayment,
  createTranche,
  updateTranche,
  deleteTranche,
};

export interface AddRegistrationTrancheRequest {
  name: string;
  amount: number;
  dueDate: Date;
  status: RegistrationTrancheStatus;
}

export interface UpdateTrancheRequest {
  name: string;
  amount: number;
  discountedAmount: number;
  dueDate: Date;
  paymentId?: number;
}

export interface FetchUserPaymentsResponse {
  payments: UserPaymentApi[];
  leftToPay: LeftToPay;
  tranches: UserPaymentTrancheApi[];
}
export interface UserPaymentTrancheApi {
  amount: number;
  courseTrancheId: number;
  discountedAmount: number;
  dueDate: Date;
  name: string;
  paymentId: number;
  status: RegistrationTrancheStatus;
}
export interface LeftToPay {
  amount: number;
  dueDate: Date;
}
export interface UserPaymentApi {
  id: number;
  amount: string;
  paymentLink: string;
  status: number;
  createdDate: Date;
  invoice: string;
}
